<template>
	<section class="pt-4 mb-4">
    <section-title>
			{{ $t('employee-my-contract') }}
  	</section-title>
		<div v-if="contractInfo && !contractLoading">
			<b-row>
				<b-col lg="6">
					<b-card
					class="mb-4 shadow"
					no-body
					>
						<b-list-group flush>
							<b-list-group-item class="flex-column align-items-start">
								<div class="d-flex justify-content-between">
										<div class="h6 mt-1 doc-list">
												{{ $t('employee-my-contract') }}
										</div>
										<b-button
											variant="primary"
											type="light"
											target="_blank"
											size="sm"
											@click="downloadContract()"
										>
												<svgicon
													class="mr-1"
													icon="download"
												/>
												<span class="icon-text">{{ $t('download') }}</span>
										</b-button>
								</div>
							</b-list-group-item>
						</b-list-group>
					</b-card>
				</b-col>
			</b-row>

			<b-row>
				<b-col lg="12">
					<b-card class="shadow">
						<h3 slot="header" class="h5 mb-0">
							<strong>
								{{$t('lissage-part-title')}}
							</strong>
						</h3>
						<div class="display-content" v-if="contractContent" v-html="displayContent"></div>
						<div class="display-content" v-else>{{$t('no-data')}}</div>
						<div class="flex mt-3" v-if="hasAction">
								<span padding="10">{{$t('lissage-text-question')}} :</span>
								<b-form-select
									v-model="selectedTypeId"
									class="text-capitalize select-box ml-2"
									v-validate="'required'"
									:options="typeList"
									value-field="idTypeLissageInfo"
									text-field="typeLissageInfo"
									required
								/>
						</div>
					</b-card>
				</b-col>
				<div class="text-right mb-3 w-100 mr-3" v-if="hasAction">
					<b-button
							:disabled="isButtonDisable"
							type="submit"
							variant="primary"
							style="margin-top: 1rem"
							v-b-modal.confirmModal
					>
						{{ $t("my-contract-validate-button") }}
					</b-button>
				</div>
			</b-row>
		</div>

		<b-modal
				size="sm"
				id="confirmModal"
				class="modal-box"
				ref="confirmModal"
				hide-header
				hide-footer
				centered
		>
			<div class="confirm-content" v-html="$t('lissage-text-popup-confirmation')">
			</div>
			<div class="mt-3 text-center">
				<b-button class="mr-4" @click="hideModal">
					{{ $t("my-contract-cancel-button") }}
				</b-button>
				<b-button variant="primary" @click="submit()">
					{{ $t("my-contract-validate-button") }}
				</b-button>
			</div>
		</b-modal>

		<div v-if="contractLoading" class="text-center">
			<b-spinner variant="primary" />
		</div>


		<b-alert
			class="mt-2"
			:show="!!errorMessage"
			:variant="ALERT_TYPES.DANGER"
		>
			{{ errorMessage }}
		</b-alert>
	</section>
</template>
<script>
import SectionTitle from "@/components/SectionTitle/SectionTitle.vue"
import downloadPDF from "@/mixins/downloadPDF"
import {TOKEN_FIELD_CORRESPONDING} from "@/constants/contract"
import { mapActions, mapGetters } from "vuex";
import { ALERT_TYPES } from '@/constants/variables';

export default {
	data() {
		return {
			selectedTypeId: null,
			contractLoading: true,
			errorMessage: '',
			hasAction: false,
			checkDisableBtn: false,
			isDownloading: false
		}
	},
  components: {
    SectionTitle,
  },
  mixins: [downloadPDF],
	created() {
		this.initData();
	},
	computed: {
    ...mapGetters('profile', ['contractInfo']),
    ...mapGetters('contract', ['contractList', 'tokenList']),
		typeList() {
      return this.contractInfo.allowedTypeLissageInfo;
		},
		contractUserInfo() {
      return this.contractInfo.userInfo;
		},
		defaultType() {
      return this.typeList.find(item => item.default) || null;
		},
		isButtonDisable() {
      return this.checkDisableBtn && (!this.defaultType || (this.selectedTypeId === this.contractUserInfo.idTypeLissageInfo));
		},
		selectedType() {
      return this.typeList.find(item => item.idTypeLissageInfo === this.selectedTypeId) || null;
		},
		contractContent() {
      return this.contractList.find(item => item.codeCase == this.contractUserInfo.idLissageChoiceStatus)
		},
		displayContent() {
      let result = this.contractContent.contentCase;
      this.tokenList.forEach(token => {
        const apiField = TOKEN_FIELD_CORRESPONDING[`{${token.name}}`];
        if (apiField && this.contractUserInfo[apiField]) {
          let replaceVal = this.contractUserInfo[apiField];
          if (apiField.includes('date')) {
            replaceVal = this.$options.filters.formatDateY(replaceVal);
					} else {
            replaceVal = this.$options.filters.capitalize(replaceVal);
					}
          result = result.replace(`{${token.name}}`, replaceVal)
				}
			});
			return result;
		},
		ALERT_TYPES() {
			return ALERT_TYPES;
		}
	},
	watch: {
		selectedTypeId() {
			this.errorMessage = '';
		}
	},
	methods: {
		...mapActions('profile', ['getContractInfo', 'submitContract']),
    ...mapActions('contract', ['getContractList', 'getTokenList']),
		submit() {
			this.hideModal();
      this.submitContract(this.selectedType).then(() => {
				this.initData();
			}).catch(err => {
				if (err.message) {
					this.errorMessage = err.message;
				} else {
					this.errorMessage = this.$t('backend-error')
				}
			})
		},
		downloadContract() {
			this.isDownloading = true;
			this.checkFileExistanceAndDownload(this.contractUserInfo.contractFilePath).finally(res => {
				this.isDownloading = false;
			})
		},
		hideModal(){
		  this.$bvModal.hide('confirmModal');
		},
		initData() {
			this.errorMessage = '';
			this.contractLoading = true;
			this.selectedTypeId = null;
			this.hasAction = false;
			this.checkDisableBtn = false;

			this.getContractList();
			this.getTokenList();
			this.getContractInfo().then(() => {
				if (this.contractContent) {
					this.defineAction();
				}
				this.contractLoading = false;
			});
		},
		defineAction() {
			switch(this.contractContent.codeAction) {
				case 'Trait001':
					this.selectedTypeId = this.defaultType ? this.defaultType.idTypeLissageInfo : null;
					this.hasAction = true;
					break;
				case 'Trait002':
					this.selectedTypeId = this.contractUserInfo.idTypeLissageInfo;
					this.checkDisableBtn = true;
					this.hasAction = true;
					break;
				default:
					this.hasAction = false;
					break;
			}
		}
	}
}
</script>

<style scoped>
	.confirm-content, .display-content {
		white-space: pre-wrap;
	}
	.select-box {
		width: fit-content;
	}
</style>